import * as React from 'react';

// @ts-expect-error
import type {FieldProps} from 'redux-form';

import {FormField} from 'shells/form/form-field';
import {RadioButton} from 'shells/radio/radio-button';
import {RadioGroup} from 'shells/radio/radio-group';
import {TextField} from 'shells/textfield/textfield';

import {getReduxFormError} from './helpers';

type BaseProps = {
    title: string;
    options: {
        value: string;
        title: string;
    }[];
    isRequired?: boolean;
    labelIsTwoLines?: boolean;
    includeOther?: boolean;
};

type ReduxFormProps = BaseProps &
    FieldProps & {
        variant: 'redux-form';
    };

type ControlledProps = BaseProps & {
    variant: 'controlled';
    name: string;
    value: string | null | undefined;
    onChange: (value: string) => void;
    error?: string | null | undefined;
};

type Props = ReduxFormProps | ControlledProps;

export function TinyIntroRadioButtons(props: Props) {
    const name = props.variant === 'redux-form' ? props.input.name : props.name;
    const externalValue = props.variant === 'redux-form' ? props.input.value : props.value;
    const onChangeExternal = props.variant === 'redux-form' ? props.input.onChange : props.onChange;
    const error = props.variant === 'redux-form' ? getReduxFormError(props.meta) : props.error;

    const [selectedValue, setSelectedValue] = React.useState<string | null | undefined>(
        externalValue || ''
    );
    const [textfieldValue, setTextfieldValue] = React.useState<string>('');

    const options = props.includeOther
        ? props.options.concat({value: 'other', title: 'Other'})
        : props.options;

    React.useEffect(() => {
        if (selectedValue) {
            if (selectedValue === 'other') {
                onChangeExternal(textfieldValue);
            } else {
                onChangeExternal(selectedValue);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedValue, textfieldValue]);

    // @ts-expect-error
    const onChange = (selection) => {
        setSelectedValue(selection);
    };

    // @ts-expect-error
    const getRadioContent = (option) => {
        if (option.value === 'other') {
            return (
                <div className='flex align-center'>
                    <div style={{marginRight: '8px'}}>Other:</div>
                    <TextField
                        value={textfieldValue}
                        onChange={(value) => setTextfieldValue(value)}
                        onFocus={() => setSelectedValue('other')}
                    />
                </div>
            );
        } else {
            return option.title;
        }
    };

    return (
        <FormField
            innerId={name}
            label={props.title}
            errorMessage={error}
            isRequired={props.isRequired}
            labelIsTwoLines={props.labelIsTwoLines}
        >
            <RadioGroup name={name} selectedValue={selectedValue} onChange={onChange} spacing={0}>
                {/* @ts-expect-error */}
                {options.map((option) => {
                    return (
                        <RadioButton key={option.value} value={option.value} isLarge={true}>
                            {getRadioContent(option)}
                        </RadioButton>
                    );
                })}
            </RadioGroup>
        </FormField>
    );
}
